import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export const getOffset = element => {
  const box = element.getBoundingClientRect()

  return {
    top: box.top + window.scrollY - document.documentElement.clientTop,
    left: box.left + window.scrollY - document.documentElement.clientLeft,
  }
}

const createGrid = () => {
	const grid = document.createElement("section");
	grid.id = "grid";
	let colNumbers;

	switch (true) {
		case window.innerWidth < 600:
			colNumbers = 4;
			break;
		case window.innerWidth < 900:
			colNumbers = 8;
			break;
		case window.innerWidth >= 1024:
			colNumbers = 12;
			break;
	}

	for (let index = 0; index < colNumbers; index++) {
		const col = document.createElement("article");
		col.classList.add("col");
		grid.appendChild(col);
	}

	document.body.appendChild(grid);
}

export const getSection = element => {
	let parent = element.parentNode;
	
	while (parent && parent.tagName !== 'SECTION') {
		parent = parent.parentNode;
	}
	
	return `.${parent.classList[0]}`;
}

export const initGrid = () => {
	document.addEventListener('keydown', event => {

		if (event.code == 'KeyG') {
			!document.getElementById("grid") ? createGrid() : document.getElementById("grid").remove();
		}

		if (event.code == 'BracketRight' && document.getElementById("grid")) {
			document.getElementById("grid").classList.add("grid-opacity");
		} else if (event.code == 'Slash' && document.getElementById("grid")) {
			document.getElementById("grid").classList.remove("grid-opacity");
		}

	})
}

export const initMultitab = () => {
	const allSwitchBtns = [...document.querySelectorAll(".multitab h3")];

	allSwitchBtns.forEach(btn => {
		btn.addEventListener("click", () => {
			const allSections = btn.parentElement.parentElement.querySelectorAll("[class^='content-']")
			const section = document.querySelector(`${getSection(btn)} .content-${btn.dataset.type}`);
			const indicator = btn.parentElement.querySelector("aside.bar");

			gsap.to(window, { duration: 1, scrollTo: { y: btn, offsetY: 100 } });

			allSwitchBtns.forEach(item => item.classList.remove("active"));
			allSections.forEach(box => box.classList.remove("active"));
		
			gsap.to(indicator, {x: btn.offsetLeft, duration: 0.3, ease: "power3.inOut"});

			section.classList.add("active");
			setActivetab(btn.dataset.type == "magistrali" ? 1 : 0);
			ScrollTrigger.refresh();
		})
	})

}

export const setActivetab = index => {
	const allTabs = [...document.querySelectorAll(`.multitab h3:nth-of-type(${index + 1})`)];
	const allSwitchBtns = [...document.querySelectorAll(".multitab h3")];
	const allActiveBtns = [...document.querySelectorAll(`.multitab h3:nth-of-type(${index + 1}`)];


	allTabs.forEach(btn => {
		const allSections = btn.parentElement.parentElement.querySelectorAll("[class^='content-']");
		const section = document.querySelector(`${getSection(btn)} .content-${btn.dataset.type}`);
		const indicator = btn.parentElement.querySelector("aside.bar");

		allSwitchBtns.forEach(item => item.classList.remove("active"));
		allSections.forEach(box => box.classList.remove("active"));
		allActiveBtns.forEach(item => item.classList.add("active"));
		gsap.to(indicator, {x: btn.offsetLeft, duration: 0.3, ease: "power3.inOut"});
		section.classList.add("active");
		ScrollTrigger.refresh();
	})
}

export const getParameterByName = (name, url) => {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
	const results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export async function post(url, params) {
	try {
	
		let response = await fetch(url, {
			method: 'POST',			
			body: params,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',		
			}
		});

		let _data = await response.json();
		console.log('informazioni ottenute');
		console.log(_data);
		return _data;
	
	} catch(e) {
		console.log('error', e);
	}
}

export const preventScroll = () => {
	const body = document.querySelector('body');

	body.classList.add('no-scroll');
	document.ontouchmove = function (e) {
		e.preventDefault();
	}
}

export const enableScroll = () => {
	const body = document.querySelector('body');

	body.classList.remove('no-scroll');
	document.ontouchmove = function (e) {
		return true;
	}
}